// Shared Asia/Manila-safe date/time helpers.
const MANILA_TIME_ZONE = "Asia/Manila";
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;
const DATE_TIME_WITHOUT_ZONE = /^\d{4}-\d{2}-\d{2}[T\s]\d{2}:\d{2}(?::\d{2}(?:\.\d{1,6})?)?$/;
const EXPLICIT_TIME_ZONE = /(Z|[+-]\d{2}:?\d{2})$/i;
const MANILA_DATE_SUFFIX = "T00:00:00+08:00";

const manilaDateKeyFormatter = new Intl.DateTimeFormat("en-CA", {
  timeZone: MANILA_TIME_ZONE,
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const manilaDateOnlyFormatter = new Intl.DateTimeFormat("en-PH", {
  timeZone: MANILA_TIME_ZONE,
  year: "numeric",
  month: "long",
  day: "numeric",
});

const manilaDateWithWeekdayFormatter = new Intl.DateTimeFormat("en-PH", {
  timeZone: MANILA_TIME_ZONE,
  weekday: "long",
  year: "numeric",
  month: "short",
  day: "numeric",
});

const toManilaDateObject = (value) => {
  const dateKey = toDateKey(value);
  if (!dateKey) return null;
  const d = new Date(`${dateKey}${MANILA_DATE_SUFFIX}`);
  return Number.isNaN(d.getTime()) ? null : d;
};

export function toDateKey(value) {
  if (!value) return "";
  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) return "";
    return manilaDateKeyFormatter.format(value);
  }
  const raw = String(value).trim();
  if (!raw) return "";
  if (DATE_ONLY.test(raw)) return raw;
  const d = new Date(normalizeDateTimeInput(raw));
  if (Number.isNaN(d.getTime())) return "";
  return manilaDateKeyFormatter.format(d);
}

export function normalizeDateTimeInput(value) {
  if (!value || value instanceof Date) return value;
  const raw = String(value).trim();
  if (!raw) return raw;
  if (DATE_ONLY.test(raw)) return raw;
  if (DATE_TIME_WITHOUT_ZONE.test(raw) && !EXPLICIT_TIME_ZONE.test(raw)) {
    return `${raw.replace(' ', 'T')}Z`;
  }
  return raw;
}

export function getCurrentDateKey() {
  return toDateKey(new Date());
}

export function formatTime12h(time24) {
  if (!time24) return "";
  const [h, m = "00"] = time24.toString().split(":");
  if (isNaN(parseInt(h, 10))) return time24;

  let hour = parseInt(h, 10);
  const minute = m.padStart(2, "0");
  const ampm = hour >= 12 ? "PM" : "AM";
  hour = hour % 12 || 12;
  return `${hour}:${minute} ${ampm}`;
}

export function formatDateTimeToTime12h(value) {
  if (!value) return "";
  const d = new Date(normalizeDateTimeInput(value));
  if (isNaN(d.getTime())) return "";
  return d.toLocaleTimeString("en-PH", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: MANILA_TIME_ZONE,
  });
}

export function formatTimeOnly(value) {
  return formatDateTimeToTime12h(value);
}

export function formatDateOnly(value) {
  const d = toManilaDateObject(value);
  if (!d) return "";
  return manilaDateOnlyFormatter.format(d);
}

export function formatDateWithWeekday(value) {
  const d = toManilaDateObject(value);
  if (!d) return "";
  return manilaDateWithWeekdayFormatter.format(d);
}

export function timePickerValueTo24hString(dateObj) {
  if (!dateObj) return null;
  const d = new Date(dateObj);
  if (isNaN(d.getTime())) return null;
  const h = d.getHours().toString().padStart(2, "0");
  const m = d.getMinutes().toString().padStart(2, "0");
  return `${h}:${m}:00`;
}
